import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

export default function TrackedSection({ children, id, title, threshold = 10000, onTrigger }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { amount: 0.5 }); // 50 % sichtbar
    const [viewTime, setViewTime] = useState(0);
    const [hasTracked, setHasTracked] = useState(false);

    useEffect(() => {
        let interval = null;

        if (isInView && !hasTracked) {
            interval = setInterval(() => {
                setViewTime((prev) => prev + 100);
            }, 100);
        } else if (!isInView && interval) {
            clearInterval(interval);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isInView, hasTracked]);

    useEffect(() => {
        if (viewTime >= threshold && !hasTracked) {
            setHasTracked(true);

            // Matomo Event
            window._paq = window._paq || [];
            window._paq.push([
                "trackEvent",
                "Section View",
                id,
                `viewed ${Math.round(viewTime / 1000)}s`,
                Math.round(viewTime / 1000),
            ]);

            if (onTrigger) onTrigger(id);

        }
    }, [viewTime, hasTracked, id, title, onTrigger]);

    return (
        <motion.section
            ref={ref}
        >
            {/* <p>Sichtzeit: {(viewTime / 1000).toFixed(1)} Sekunden</p> */}
            {children}
        </motion.section>
    );
}